module.exports = __webpack_public_path__ + "static/media/IMG_3662.eed7439b.jpg";